<div class="search-form-container">
    <!-- (con pannello dei filtri nascosto hideFilters = false) ==> Pulsanti di ricerca (unico) e cancellazione dei filtri (con pannello dei diltri nascosto hideFilters = true) -->
    <div class="search-form-action" style="flex-direction: column">
        <button
            mat-mini-fab
            class="se-nav-min-btn mat-elevation-z3"
            [class.hide-filters]="!hideFilters"
            [disabled]="isBusy || disableSearch"
            type="button"
            (click)="onSearch()"
        >
            <mat-icon class="se-nav-mini-icon" aria-label="CleanFilters" matPrefix>search</mat-icon>
        </button>

        <button
            mat-mini-fab
            class="se-nav-min-btn mat-elevation-z3"
            [class.hide-filters]="!hideFilters"
            [disabled]="isBusy || disableSearch"
            type="button"
            matTooltip="{{ 'CleanFilters' | translate }}"
            matTooltipShowDelay="500"
            (click)="onResetFilter()"
        >
            <mat-icon class="se-nav-mini-icon" aria-label="CleanFilters" matPrefix>delete</mat-icon>
        </button>
    </div>

    <!-- (con pannello dei filtri visibile hideFilters = false) ==> Pulsanti di ricerca (multiplo) - filtri di ricerca - cancellazione filtri (in basso) -->
    <!-- Aggiungere al div qui sotto se si vuole il context menu:  (contextmenu)="onContextMenu($event)" -->
    <div class="search-filter-container" [class.hide-filters]="hideFilters">
        <div class="search-form-actions-panel" style="margin: 5px 10px 0 5px">
            <div style="flex: 1; flex-direction: row" class="search-form-action">
                <button
                    mat-button
                    class="search-panel-button se-button-no-ripple se-flex-1"
                    [disabled]="isBusy || disableSearch"
                    type="button"
                    (click)="onSearch()"
                    matTooltip="{{ 'Search' | translate }}"
                    matTooltipShowDelay="500"
                >
                    <mat-icon class="search-filter-search-icon">search</mat-icon>
                    <span *ngIf="!isMultiSearchEnabled" style="margin-left: 3px">{{ "Search" | translate }}</span>
                    <span *ngIf="isMultiSearchEnabled" style="margin-left: 3px">{{
                        actualSearchType?.labelTranslationKey ?? "" | translate
                    }}</span>
                </button>
                <button
                    mat-icon-button
                    *ngIf="isMultiSearchEnabled"
                    class="search-panel-button"
                    [disabled]="isBusy || disableSearch"
                    [matMenuTriggerFor]="searchTypeMenu"
                    type="button"
                >
                    <mat-icon aria-label="Menu ricerche" matPrefix>keyboard_arrow_right</mat-icon>
                </button>
                <mat-menu #searchTypeMenu="matMenu" yPosition="above" xPosition="after" class="se-mat-menu">
                    <div
                        style="align-items: flex-start; display: flex; flex-direction: column"
                        *ngFor="let type of searchTypes"
                    >
                        <button mat-menu-item class="se-menu-button se-menu-button" (click)="onChangeSearchType(type)">
                            <span>{{ type.labelTranslationKey | translate }}</span>
                        </button>
                    </div>
                </mat-menu>
            </div>
        </div>

        <div id="searchform" class="search-form-content">
            <se-search-filter
                [formType]="formType"
                [searchParams]="searchParams"
                [searchOnInit]="searchOnInit"
                (searchRequired)="onSearch()"
                (resetFilterRequired)="onResetFilter()"
                (disableSearchRequired)="onDisableSearch($event)"
                [filterChangeOps]="fnFilterChangeOpsHandler"
                [itemSourceOps]="fnItemSourceOpsHandler"
            >
            </se-search-filter>
        </div>

        <div class="search-form-actions-panel" style="margin: 0 10px 5px 5px">
            <div style="flex: 1" class="search-form-action">
                <button
                    mat-button
                    class="search-panel-button se-flex-1 se-button-no-ripple"
                    [disabled]="isBusy || disableSearch"
                    type="button"
                    (click)="onResetFilter()"
                    matTooltip=" {{ 'CleanFiltersDetail' | translate }}"
                    matTooltipShowDelay="500"
                >
                    {{ "CleanFilters" | translate }}
                </button>

                <mat-divider *ngIf="favorites" class="se-header-divider" [vertical]="true"></mat-divider>

                <button
                    mat-icon-button
                    class="se-button-config"
                    *ngIf="favorites"
                    matTooltip="{{ 'FavoriteFilters' | translate }}"
                    matTooltipPosition="above"
                    [matMenuTriggerFor]="filterConfigMenu"
                >
                    <mat-icon>settings</mat-icon>
                </button>
                <mat-menu #filterConfigMenu="matMenu" yPosition="above" xPosition="before">
                    <div class="se-mat-menu">
                        <button
                            *ngIf="favorites && favorites.length > 0"
                            mat-menu-item
                            class="se-filter-config-menu-item se-menu-button"
                            [matMenuTriggerFor]="filterConfigColumnsSubMenu"
                        >
                            {{ "FavoriteFilterList" | translate }}
                        </button>
                        <button
                            (click)="newFavoriteFilterPopup = true"
                            class="se-filter-config-menu-item se-menu-button"
                            mat-menu-item
                        >
                            {{ "FavoriteFilterSave" | translate }}
                        </button>
                    </div>

                    <mat-menu #filterConfigColumnsSubMenu="matMenu" style="padding: 0px 5px">
                        <div
                            mat-menu-item
                            *ngFor="let filter of favorites"
                            class="se-menu-item se-filter-config-container"
                            (click)="onActivateFavoriteFilter(filter)"
                        >
                            <div class="se-filter-config-sub-container">
                                <mat-icon
                                    class="se-menu-button se-filter-config-favorite-button"
                                    *ngIf="!filter.isDefault"
                                    (click)="onSetDefaultFavoriteFilter(filter)"
                                    matTooltip="{{ 'FavoriteFilterNewDefault' | translate }}"
                                    matTooltipPosition="above"
                                    >star_outline</mat-icon
                                >

                                <mat-icon
                                    *ngIf="filter.isDefault"
                                    class="se-menu-button se-filter-config-favorite-button"
                                    (click)="onSetDefaultFavoriteFilter(filter, true)"
                                    matTooltip="{{ 'FavoriteFilterDefault' | translate }}"
                                    matTooltipPosition="above"
                                    >star</mat-icon
                                >

                                <span class="se-filter-config-favorite-text">{{ filter.name | translate }}</span>

                                <mat-icon
                                    class="se-menu-button se-filter-config-favorite-button"
                                    (click)="onDeleteFavoriteFilter(filter)"
                                    matTooltip="{{ 'FavoriteFilterDelete' | translate }}"
                                    matTooltipPosition="above"
                                    >delete</mat-icon
                                >
                            </div>
                        </div>
                    </mat-menu>
                </mat-menu>
            </div>
        </div>

        <se-modaldialog
            [buttonCancel]="true"
            [buttonOk]="true"
            [header]="'FavoriteFilterNewTitle' | translate"
            [(visible)]="newFavoriteFilterPopup"
            (buttonClick)="onSaveFavoriteFilter($event)"
            class="custom-data-dialog"
            [windowSize]="3"
        >
            <div content>
                {{ "FavoriteFilterNewDescription" | translate }}

                <div class="newFavoriteFilterPopup">
                    <div class="row">
                        <div class="col-md-6">
                            <label for="newFavoriteFilterName">{{ "FavoriteFilterNewName" | translate }}</label>
                        </div>
                        <div class="col-md-6">
                            <mat-form-field>
                                <input matInput name="newFavoriteFilterName" [(ngModel)]="newFavoriteFilterData.name" />
                            </mat-form-field>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-md-6">
                            <label for="newFavoriteFilterDefault">{{ "FavoriteFilterNewDefault" | translate }}</label>
                        </div>
                        <div class="col-md-6">
                            <mat-checkbox
                                labelPosition="before"
                                [checked]="newFavoriteFilterData.isDefault"
                                (change)="newFavoriteFilterData.isDefault = !newFavoriteFilterData.isDefault"
                            >
                            </mat-checkbox>
                        </div>
                    </div>
                </div>
            </div>
        </se-modaldialog>
    </div>

    <!-- Griglia risultati -->
    <div class="search-result">
        <div id="searchresult" class="search-result-content">
            <se-search-result
                [formType]="formType"
                [items]="(searchResult$ | async) ?? []"
                [rowSelection]="rowSelection"
                [idPropertyName]="idPropertyName"
                [disabledShowHideIdList]="disabledShowHideIdList"
                [postLoadingSelectionOps]="postLoadingSelectionOps"
                [canItemBeSelected]="fnCanItemBeSelectedHandler"
                [canItemDoubleClicked]="fnCanItemDoubleClickedHandler"
                [canPatientHistoryOpenForSelection]="fnCanPatientHistoryOpenForSelectionHandler"
                [getTooltipForSelection]="fnGetTooltipForSelectionHandler"
                [getButtonContentForSelection]="fnGetButtonContentForSelectionHandler"
                [keepSelectionAfterSearch]="keepSelectionAfterSearch"
                [isBusy]="isBusy"
            ></se-search-result>

            <!-- Spinner -->
            <div class="estensa-spinner" *ngIf="isBusy">
                <mat-spinner></mat-spinner>
            </div>
        </div>
    </div>
</div>
